<!--想去那里玩  view:19-->
<template>
    <div class="View18Wrapper cardWidth shadowRadius cardPadding cardMinHeight">
        <div class="helpInfo">
            <div class="helpTitle">
                <img src="../../assets/img/traffic.png" alt="交通" class="helpImg">
                <div class="titleText">{{list.traffic.name}}</div>
            </div>
            <div class="helpDetails">
                <div class="baseText overFourLine">{{list.traffic.children}}</div>
                <Pointer text="查看详情" @on-click="()=>onToast(list.traffic.name,list.traffic.toastType,list.traffic.children)"/>
            </div>
        </div>
        <div class="divider"></div>
        <div class="helpInfo">
            <div class="helpTitle">
                <img src="../../assets/img/openTime.png" alt="开放时间" class="helpImg">
                <div class="titleText">{{list.openTime.name}}</div>
            </div>
            <div class="helpDetails">
                <div class="baseText overFourLine">{{list.openTime.children}}</div>
                <!--                <Pointer text="查看详情" @on-click="()=>onToast(list.traffic.name,list.traffic.toastType)"/>-->
            </div>
        </div>
    </div>
</template>
<script>
    import Pointer from "../Use/pointer";
    import {mapMutations} from "vuex";
    export default {
        name: "View18",
        components: {Pointer},
        props: {
            tips: {
                type: String,
                default: ""
            },
            list: {
                type: Object,
                default: () => {
                }
            }
        },
        data() {
            return {

            };

        },
        methods: {
            ...mapMutations([
                "setToastContent","setToastShow"
            ]),
            onToast(name,toastType,children){
                this.setToastShow(true)
                this.setToastContent({toastType,list:{name:name,content:children}})
            },
        }
    };
</script>
<style lang="less" scoped>
    .View18Wrapper {
        .divider {

            height: 1px;
            background: rgba(234, 241, 249, 1);
            margin: .6rem 0;
        }

        .helpInfo {

            .helpTitle {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-bottom: .4rem;

                .helpImg {
                    width: .8rem;
                    height: .8rem;
                }

                .titleText {
                    font-size: .42rem;
                    color: #171E32;
                    margin-left: .2rem;
                    font-weight: 700;
                }
            }


            .helpDetails {
                .baseText {
                    color: #646772;
                    font-size: .38rem;

                }
            }

            .overFourLine {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }


        }

    }
</style>
